import type { RuntimeShellContext } from "../context/execution-context";
import type { ResolvedScreen } from "./index-types";
import { isPlainObject } from "./StudioScreenRenderer.utils.data";

function defaultShellIcon(slug: string): string {
  if (
    ["content", "content-item", "favourites", "course", "exercise", "challenge"]
      .includes(slug)
  ) {
    return "book-open";
  }
  if (slug === "tasks") return "target";
  if (slug === "portrait") return "lightbulb";
  if (slug === "settings" || slug === "onboarding-settings") return "settings";
  return "layout-grid";
}

function readNonEmptyString(value: unknown): string | null {
  return typeof value === "string" && value.trim() ? value.trim() : null;
}

export function deriveShellHeaderForScreen(
  screen: ResolvedScreen,
): RuntimeShellContext {
  const shellMeta = isPlainObject(screen.manifest.meta?.shell)
    ? screen.manifest.meta.shell
    : {};
  return {
    title: readNonEmptyString(shellMeta.title) ??
      readNonEmptyString(screen.manifest.title) ?? "Mneno",
    description: readNonEmptyString(shellMeta.description) ??
      "Support that moves at your pace.",
    icon: readNonEmptyString(shellMeta.icon) ??
      defaultShellIcon(screen.manifest.slug),
  };
}